import React, { PropsWithChildren, ReactNode } from 'react';
import classnames from 'classnames';
import { ConnectionTypeChip } from 'new/elements/ConnectionTypeChip/ConnectionTypeChip';

import styles from './FormConfigurationStep.module.scss';
import { Typography } from '@mui/material';

type Props = PropsWithChildren<{
  enableCategoryHeader?: boolean;
  connectionName?: string | ReactNode;
  connectionIcon?: ReactNode;
  containerClassname?: string;
  innerContainerClassname?: string;
  formContainerClassname?: string;
  headerChildren?: ReactNode;
  headerComponent?: ReactNode;
}>;

export function FormConfigurationStep(props: Props) {
  const { enableCategoryHeader = true, headerComponent } = props;

  const _classNameContainer = classnames(props.containerClassname ?? styles.container);

  const _innerContainerContent = classnames(
    props.innerContainerClassname ?? styles.innerContainerContent,
  );

  const _formContainerClassname = classnames(
    props.formContainerClassname ?? styles.createContentForm,
  );

  let header = null;
  if (enableCategoryHeader) {
    header = (
      <div className={styles.categoryHeader}>
        <div className={styles.chip}>
          <ConnectionTypeChip
            icon={props.connectionIcon}
            iconOnly
            style={{ border: 'none', padding: 0 }}
          />
          <div className={styles.logoSeparator} />
          <Typography variant="bodySmall" className={styles.logoLabel}>
            {props.connectionName}
          </Typography>
        </div>
        {props.headerChildren ? props.headerChildren : null}
      </div>
    );
  }

  return (
    <div className={_classNameContainer}>
      {header}
      {headerComponent}

      <div className={_innerContainerContent}>
        <section className={_formContainerClassname}>{props?.children}</section>
      </div>
    </div>
  );
}
